export const advancedInsights = {
  'AccountPerformanceReport-SixWeeks': {
    mandatory: [
      'CustomerName',
      'AccountName',
      'AccountNumber',
    ],
    default: [
      'CustomerName',
      'AccountName',
      'AccountNumber',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'AveragePosition',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
  },
  'AccountPerformanceReport-TwoMonths': {
    mandatory: [
      'CustomerName',
      'AccountName',
      'CustomerId',
      'AccountNumber',
    ],
    default: [
      'CustomerName',
      'AccountName',
      'CustomerId',
      'AccountNumber',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'AveragePosition',
      'Conversions',
    ],
  },
  'AccountPerformanceReport-TwoYears': {
    mandatory: [
      'CustomerName',
      'AccountName',
      'AccountNumber',
    ],
    default: [
      'CustomerName',
      'AccountName',
      'AccountNumber',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'AveragePosition',
      'Conversions',
    ],
  },
  'AccountPerformanceReport-ShareOfVoice': {
    mandatory: [
      'Keyword',
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'Language',
      'ImpressionSharePercent',
      'BidMatchType',
    ],
    default: [
      'Keyword',
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'Language',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'AveragePosition',
      'ImpressionSharePercent',
      'ImpressionLostToBudgetPercent',
      'ImpressionLostToRankAggPercent',
      'BidMatchType',
    ],
  },
};
